<template>
    <sui-segment>
        <h1 is="sui-header">{{ $t('customers.list.title') }}</h1>

        <!-- Filters & exports -->

        <sui-card class="fluid">
            <sui-card-content>
                <sui-button class="tiny violet" v-on:click="onExport(true)">{{ $t('common.exportAllData') }}</sui-button>
                <sui-button class="tiny violet" v-on:click="onExport()">{{ $t('common.exportFilteredData') }}</sui-button>
            </sui-card-content>
            <sui-card-content>
                <sui-form @submit="(e) => e.preventDefault()">
                    <sui-form-field>
                        <label>{{ $t('customers.list.searchByName') }}</label>
                        <div class="ui fluid action input">
                            <sui-input placeholder="Chercher par nom..." :value="query.search" @input="onSearchChange"/>
                            <sui-button v-on:click="onResetSearch()" icon="trash"/>
                        </div>
                    </sui-form-field>

                    <sui-accordion>
                        <sui-accordion-title>
                            <sui-icon name="dropdown" />
                            {{ $t('customers.list.advancedSearch') }}
                        </sui-accordion-title>
                        <sui-accordion-content>
                            <sui-form-field>
                                <sui-checkbox
                                    :label="$t('customers.list.idSageLabel')"
                                    toggle
                                    v-model="query.hasNoSageId"/>
                            </sui-form-field>

                            <sui-form-field>
                                <sui-checkbox
                                    :label="$t('customers.list.noGatewayLabel')"
                                    toggle
                                    v-model="query.hasNoGateway"/>
                            </sui-form-field>

                            <sui-form-field>
                                <label>{{ $t('customers.list.searchByGateway') }}</label>
                                <sui-dropdown
                                    :options="gateways"
                                    placeholder="State"
                                    search
                                    selection
                                    v-model="query.gateway"
                                />
                            </sui-form-field>

                            <sui-form-field>
                                <sui-button class="tiny" secondary v-on:click="onFilter()">{{ $t('customers.list.filterByTag') }}</sui-button>
                            </sui-form-field>
                        </sui-accordion-content>
                    </sui-accordion>
                </sui-form>
            </sui-card-content>
        </sui-card>

        <CustomersTable :query="query" ref="customersTable">
            <template #actions="{ customer }">
                <sui-button class="tiny" v-on:click="goToOverview(customer)">{{ $t('customers.list.overview') }}</sui-button>
            </template>
        </CustomersTable>

        <!-- Modal filter by tags -->

        <sui-modal v-model="filtering_tag">
            <sui-modal-header>{{ $t('customers.list.filterByTag') }}</sui-modal-header>
            <sui-modal-content>
                <div class="wrap">
                    <div v-for="tag in filter_tags" :key="tag.id" class="modal-tag">
                        <sui-checkbox toggle v-model="tag.selected"/>
                        <TagPill
                            v-bind:tag-id="tag.id"
                            v-bind:tag-collection="tags"
                        />
                    </div>
                </div>
                <sui-divider section/>
                <sui-modal-content>
                    <sui-checkbox :label="$t('customers.list.noTagFilter')" toggle v-model="query.hasNoTag"/>
                </sui-modal-content>
            </sui-modal-content>
            <sui-modal-actions>
                <sui-button class="tiny" v-on:click="closeModal()">{{ $t('common.cancel') }}</sui-button>
                <sui-button class="tiny violet" v-on:click="onAcceptFilter()">{{ $t('common.toFilter') }}</sui-button>
            </sui-modal-actions>
        </sui-modal>
    </sui-segment>
</template>

<style scoped>
.wrap {
    column-count: 2;
}

.modal-tag {
    display: flex;
    align-items: center;
    width: 50%;
    margin-bottom: 20px;
}
</style>

<script>
import TagPill from '@/components/tag/TagPill.vue';
import CustomersTable from '@/components/customers/CustomersTable.vue';
import { debounce } from '@/utils';
import { api } from '@/api';
import store from '@/store';

export default {
    name: 'CustomersList',
    components: {
        TagPill,
        CustomersTable,
    },
    mounted() {
        store.commit('setAppTitle', `${this.$t('common.customers')}`);
    },
    beforeDestroy() {
        store.commit('removeAppTitle');
    },
    data() {
        return {
            tags: [],
            filter_tags: [],

            filtering_tag: false,
            editing_customer: null,

            onSearchChange: debounce((value) => this.query.search = value, 400),
            query: {
                search: '',
                hasNoSageId: false,
                hasNoGateway: false,
                hasNoTag: true,
                gateway: '',
                tags: [],
            }
        }
    },
    created() {
        this.getTags();
        this.$store.dispatch('getGateways');
    },
    computed: {
        gateways() {
            return this.$store.state.gateways.map(({ id, name }) => ({ key: id, value: id, text: name }));
        },
    },
    methods: {
        async getTags() {
            this.tags = this.filter_tags = await api.customers.getTags();
            this.filter_tags.forEach((t) => t.selected = true);
        },

        closeModal() {
            this.editing_customer = null;
            this.filtering_tag = false;
        },

        onFilter() {
            this.filtering_tag = true;
        },

        onAcceptFilter() {
            this.query.tags = this.tags.filter(t => t.selected).map(t => t.id);
            this.closeModal();
        },

        onResetSearch() {
            this.query.search = '';
        },

        async onExport(full = false) {
            const params = full ? {} : { ...this.query };
            const blob = await api.customers.export(params);

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.setAttribute("href", url);
            link.setAttribute("download", "customers.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        goToOverview(customer) {
            this.$router.push({
                path: `/customers/${customer.id}/overview`,
            })
        }
    }
}
</script>
